import http from './http'
import api from '../api'

function getChannels () {
  return http({
    method: 'GET',
    url: '/channels'
  })
}

function getChannelById (id) {
  return http({
    method: 'GET',
    url: '/channels/' + id
  })
}

function getChannelAvatarById (id) {
  return api.baseURL + '/channels/' + id + '/avatar'
}

function deleteChannelAvatarById (id) {
  return http({
    method: 'DELETE',
    url: '/channels/' + id + '/avatar'
  })
}

function createChannel (params) {
  let data = new FormData()
  for (let key in params) {
    data.append(key, params[key])
  }

  return http({
    method: 'POST',
    url: '/channels',
    data
  })
}

function updateChannelById (id, params) {
  let data = new FormData()
  for (let key in params) {
    data.append(key, params[key])
  }

  return http({
    method: 'POST',
    url: '/channels/' + id,
    data
  })
}

function addGroups (id, array) {
  return http({
    method: 'PUT',
    url: '/channels/' + id + '/groups',
    data: {
      ids: array
    }
  })
}

function deleteGroups (id, array) {
  return http({
    method: 'DELETE',
    url: '/channels/' + id + '/groups',
    data: {
      ids: array
    }
  })
}

function addUsers (id, array) {
  return http({
    method: 'PUT',
    url: '/channels/' + id + '/users',
    data: {
      ids: array
    }
  })
}

function deleteUsers (id, array) {
  return http({
    method: 'DELETE',
    url: '/channels/' + id + '/users',
    data: {
      ids: array
    }
  })
}

function lock (id) {
  return http({
    method: 'POST',
    url: '/channels/' + id + '/lock'
  })
}

function unlock (id) {
  return http({
    method: 'POST',
    url: '/channels/' + id + '/unlock'
  })
}

export {
  getChannels,
  getChannelById,
  getChannelAvatarById,
  deleteChannelAvatarById,
  updateChannelById,
  createChannel,

  addGroups,
  deleteGroups,
  addUsers,
  deleteUsers,
  lock,
  unlock
}



// WEBPACK FOOTER //
// ./src/services/api/channel.js